<template>
  <ul class="nav nav-tabs">
    <li class="nav-item">
      <router-link
        to="sections"
        class="nav-link"
        :class="{ active: this.$route.params.active == 'sections' }"
        >Secciones</router-link
      >
    </li>
    <li class="nav-item">
      <router-link
        to="columns"
        class="nav-link"
        :class="{ active: this.$route.params.active == 'columns' }"
        >Columnas</router-link>
    </li>
    <li class="nav-item">
      <router-link
        to="inventory-sections"
        class="nav-link"
        :class="{ active: this.$route.params.active == 'inventory-sections' }"
        >Tipos de reporte</router-link>
    </li>
  </ul>
</template>

<script>

export default {

  name: 'InventoryComponentHeader'

};

</script>
